<template>
    <span
        v-if="$slots.default"
        :class="[
            'base-badge',
            `base-badge--${variant}`,
        ]"
        v-bind="$attrs"
    >
        <slot />
        <BaseIcon
            v-if="icon"
            class="base-badge__icon"
            :icon="icon"
        />
    </span>
</template>
<script setup lang="ts">
defineProps<{
    variant?: 'primary' | 'secondary' | 'ghost' | 'dark';
    icon?: string;
}>();
</script>
<style lang="less" scoped>
.base-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
    font-weight: var(--font-weight-primary-bold);
    border-radius: 9999px;
    white-space: nowrap;
    gap: 0.25rem;

    &__icon {
        font-size: 1em;
        line-height: 0;
    }

    &--primary {
        background-color: var(--color-primary);
        color: var(--color-lightest);
    }

    &--secondary {
        background-color: var(--color-secondary);
        color: var(--color-lightest);
    }

    &--ghost {
        background: transparent;
        color: var(--color-primary);
        border: 1px solid var(--color-primary);
    }

    &--dark {
        background-color: var(--color-darkest);
        color: var(--color-lightest);
    }
}
</style>
